import { Route } from "react-router-dom";
import ProtectedRoute from "../protectedRoute";
import CommonRoute from "../commonRoute";
import ReimbursementDashboard from "../../main/reimbursement/page";
import MyExpenses from "../../main/reimbursement/myExpenses/page";
import ManagerApprovals from "../../main/reimbursement/managerApprovals/page";
import FinanceQueue from "../../main/reimbursement/financeQueue/page";
import ExpenseDetail from "../../main/reimbursement/expenseDetail/page";
import CategoryManagement from "../../main/reimbursement/categoryManagement/page";

const reimbursementRoute = [
  {
    path: "/reimbursement",
    element: <ReimbursementDashboard />,
    module: "reimbursement",
    subModule: "dashboard", // Fixed to match menuConfig
    bypass: [0, 1], // Super Admin & Workspace Admin only - Staff cannot access
  },
  {
    path: "/reimbursement/my-expenses",
    element: <MyExpenses />,
    module: "reimbursement",
    subModule: "my-expenses",
  },
  {
    path: "/reimbursement/manager-approvals",
    element: <ManagerApprovals />,
    module: "reimbursement",
    subModule: "approvals",
    bypass: [0, 1], // Super Admin & Workspace Admin
  },
  {
    path: "/reimbursement/finance-queue",
    element: <FinanceQueue />,
    module: "reimbursement",
    subModule: "finance",
    bypass: [0, 1], // Super Admin & Workspace Admin
  },
  {
    path: "/reimbursement/expenses/:id",
    element: <ExpenseDetail />,
    module: "reimbursement",
    subModule: "my-expenses", // Use same submodule as my-expenses for permission check
  },
  {
    path: "/reimbursement/categories",
    element: <CategoryManagement />,
    module: "reimbursement",
    subModule: "categories",
    bypass: [0, 1], // Super Admin & Workspace Admin only
  },
];

export default function renderReimbursementRoutes() {
  const renderRoute = (route, access = false) => {
    return (
      <Route
        key={route.path}
        path={route.path}
        element={
          access ? (
            route.element
          ) : (
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              path={route.path}
              bypass={route.bypass}
            >
              {route.element}
            </ProtectedRoute>
          )
        }
      />
    );
  };

  return reimbursementRoute.map((route) => renderRoute(route));
}

